import { getOmsContext, getKnownOmsRole } from '@/website/backend/oms/oms_service'

export const OMS_ROLE = { ADMIN: 'ADMIN', CREATOR: 'CREATOR', APPROVER: 'APPROVER' }

// เมนูทั้งหมดที่ผู้ใช้ OMS เห็น และ role ที่เห็นได้ ใช้ทั้งใน Toolbar และ guard ของ route
// ผู้ใช้ OMS ไม่เห็นเมนูเดิมของระบบ ยกเว้นรายการที่ใส่ไว้ที่นี่ (สินค้าของฉัน สำหรับ Admin)
export const OMS_MENU = [
  // รายการแรกที่ role เห็นคือหน้าแรกหลัง login
  { path: '/oms/order', title: 'order_list', icon: 'mdi-clipboard-list-outline', roles: [OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER] },
  { path: '/oms/add-order', title: 'add_order', icon: 'mdi-cart-plus', roles: [OMS_ROLE.ADMIN, OMS_ROLE.CREATOR] },
  { path: '/oms/stock', title: 'stock', icon: 'mdi-package-variant-closed', roles: [OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER] },
  // เมนูที่มี group อยู่เป็นเมนูย่อยของกลุ่มนั้น เรียงตามลำดับในนี้ และกลุ่มแสดงที่ตำแหน่งของเมนูย่อยตัวแรก
  { path: '/my-product', title: 'my_product', icon: 'mdi-store', roles: [OMS_ROLE.ADMIN], group: 'stock_group' },
  { path: '/oms/location', title: 'location', icon: 'mdi-map-marker-multiple', roles: [OMS_ROLE.ADMIN], group: 'stock_group' },
  { path: '/oms/quota', title: 'quota', icon: 'mdi-chart-pie', roles: [OMS_ROLE.ADMIN], group: 'stock_group' },
  { path: '/transfer-list', title: 'warehouse_transfer', icon: 'mdi-swap-horizontal', roles: [OMS_ROLE.ADMIN], group: 'stock_group' },
  { path: '/oms/store', title: 'store', icon: 'mdi-storefront', roles: [OMS_ROLE.ADMIN] },
  // ทุกสิทธิ์เข้าได้: Admin จัดการผู้ใช้ทุกคน ส่วนสิทธิ์อื่นเห็นเฉพาะตัวเองเพื่อเปลี่ยนรหัสผ่าน
  { path: '/oms/user', title: 'user', icon: 'mdi-account-multiple', roles: [OMS_ROLE.ADMIN, OMS_ROLE.CREATOR, OMS_ROLE.APPROVER] }
]

// ไอคอนของกลุ่มเมนู
const OMS_MENU_GROUP_ICON = {
  stock_group: 'mdi-warehouse'
}

// หน้าที่ไม่อยู่ในเมนูแต่เปิดต่อจากเมนูได้ (รายละเอียดคำสั่งซื้อ และหน้าเพิ่ม/แก้ไขเดิมของระบบ)
const OMS_EXTRA_PATH = {
  [OMS_ROLE.ADMIN]: ['/oms/order-detail', '/my-product/update', '/transfer-list/update'],
  [OMS_ROLE.CREATOR]: ['/oms/order-detail'],
  [OMS_ROLE.APPROVER]: ['/oms/order-detail']
}

export function omsMenuOf (context) {
  if (context == null || !context.isOmsUser) {
    return []
  }
  return OMS_MENU.filter(menu => menu.roles.includes(context.role))
}

// เมนูสำหรับแสดงใน Toolbar: รวมเมนูที่มี group เดียวกันเป็นรายการเดียว { group, title, icon, children }
export function omsMenuTreeOf (context) {
  const tree = []
  for (const menu of omsMenuOf(context)) {
    if (!menu.group) {
      tree.push(menu)
      continue
    }
    let group = tree.find(item => item.group === menu.group && item.children)
    if (group == null) {
      group = { group: menu.group, title: menu.group, icon: OMS_MENU_GROUP_ICON[menu.group], children: [] }
      tree.push(group)
    }
    group.children.push(menu)
  }
  return tree
}

export function omsHomePath (role) {
  const menu = OMS_MENU.find(item => item.roles.includes(role))
  return menu != null ? menu.path : null
}

export function isPathAllowedForOms (role, path) {
  return OMS_MENU.some(menu => menu.path === path && menu.roles.includes(role)) ||
    (OMS_EXTRA_PATH[role] || []).includes(path)
}

// guard ของ route /oms/... : ซ่อนเมนูอย่างเดียวไม่พอ ต้องกันการพิมพ์ URL ตรงด้วย
// (สิทธิ์จริงบังคับที่ backend อีกชั้น)
export function OmsGuard (roles) {
  return async (to, from, next) => {
    const context = await getOmsContext()
    if (!context.isOmsUser) {
      next('/order')
    } else if (!roles.includes(context.role)) {
      next(omsHomePath(context.role) || '/order')
    } else {
      next()
    }
  }
}

// ใช้ใน router.beforeEach: ผู้ใช้ OMS เปิดหน้าเดิมของระบบที่ไม่อยู่ในเมนูของตนไม่ได้
// ตัดสินจากค่าที่จำไว้เท่านั้น จึงไม่หน่วงการเปลี่ยนหน้าของผู้ใช้ทั่วไป
// คืน path ที่ต้องพาไปแทน หรือ null เมื่อเปิดได้
export function omsRedirectFor (to, backendPath) {
  const role = getKnownOmsRole()
  if (role == null || to.matched.length == 0 || to.matched[0].path !== backendPath) {
    return null
  }
  if (isPathAllowedForOms(role, to.path)) {
    return null
  }
  const home = omsHomePath(role)
  return home != null && home !== to.path ? home : null
}
